import React from "react";
import CashflowPlanung from "../CashflowPlanung";

const CashflowWidget = () => (
  <div className="widget-content-scroll">
    <CashflowPlanung compact={true} />
  </div>
);

export default CashflowWidget;
